import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  loginConfirmedAction,
} from "../../../store/actions/AuthActions";
// image
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import logo2 from "../../../images/goOne-logo.png";
import OTPInput, { ResendOTP } from "otp-input-react";
var tokens = "";
export function tokenget(token) {
  console.log("token",token)
  tokens = token;
}
export default function OtpVerification() {
  const history = useHistory();
  const [OTP, setOTP] = useState("");
  let errorsObj = { otp: "" };
  const [errors, setErrors] = useState(errorsObj);
  var userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();
  const Permission = [
    { title: "Dashboard", path: "/" },
    { title: "All Users", path: "/user-customer" },
    { title: "Riders", path: "/riders" },
    { title: "Riders Applied", path: "/rider-applied" },
    { title: "Rejected Riders", path: "/rejected-rider" },
    { title: "Blocked Riders", path: "/blocked-rider" },
    { title: "Add Price", path: "/rider-pricing" },
    { title: "Price List", path: "/pricing-list" },
    { title: "Taxes", path: "/taxes" },
    { title: "Riders/Clint Commission", path: "/Rider/Clint-Commission" },
    { title: "AllOrders", path: "/all-orders" },
    { title: "Geofences", path: "/geofence" },
    { title: "Create Geofence", path: "/polyLine" },
    { title: "All Geofence", path: "/All-Polylines" },
    { title: "All Staff", path: "/all-staff" },
    { title: "Roles", path: "/all-roles" },
    { title: "Serviceable Area", path: "/serviceable-area" },
    { title: "Banners", path: "/banners" },
    { title: "Trending Banners", path: "/trending-banners" },
    { title: "Go One Category", path: "/go-category" },
    { title: "Go One Coupens", path: "/coupens" },
    { title: "Stores", path: "/stores" },
    { title: "Products", path: "/products" },
    { title: "Grocery SubCategory", path: "/Grocery-SubCategory" },
    { title: "Grocery Category", path: "/Grocery-Category"},
    { title: "Sub Store", path: "/Sub-Store" },
    { title: "Rider Support", path: "/support" },
    { title: "Customer Support", path: "/customer-support" },
    { title: "UPI Transactions", path: "/transaction" },
    { title: "Payout Of Rider(Taxi & Movers)", path: "/payout" },
    { title: "Login Screen Gif", path: "/logingif" },
    { title: "Partners", path: "/partner" },
    { title: "Applied Partners", path: "/applied-partners" },
    { title: "Blocked Partners", path: "/blocked-partner" },
    { title: "Training", path: "/Training" },
    { title: "Deleted User", path: "/deleted-user" },
    { title: "CashBack", path: "/cash-back" },
    { title: "Movers Categories", path: "/Movers-Categories" },
    { title: "FAQ", path: "/FAQ" },
    { title: "Rider Map View", path: "/Rider-View" },
    { title: "Health Centers", path: "/Health-Center" },
    { title: "Customer Notification", path: "/Customer-Notification" },
    { title: "User Analytics", path: "/User-Analytics" },
    { title: "Sub Tests", path: "/Sub-Tests" },
    { title: "Rider Register", path: "/Rider-Register" },
    { title: "Restaurant Owners", path: "/Restaurant-Owners" },
    { title: "Applied Owners", path: "/Applied-Owners" },
    { title: "Blocked Owners", path: "/Blocked-Owners" },
    { title: "Verified Restaurant", path: "/Verified-Restaurant" },
    { title: "Applied Restaurants", path: "/Applied-Restaurants" },
    { title: "Blocked Restaurants", path: "/Blocked-Restaurants" },
    // { title: "All Items", path: "/All-Items" },
    { title: "Applied Items", path: "/Applied-Items" },
    // { title: "All Addons", path: "/All-Addons" },
    { title: "Applied Addons", path: "/Applied-Addons" },
    { title: "Quotes", path: "/Quotes" },
    { title: "Payment Options", path: "/Payment-Options" },
    { title: "Offers", path: "/Offers" },
    { title: "Food Coupens", path: "/Food-Coupens" },
    { title: "Home Category", path: "/Home-Category" },
    { title: "Food Campaign", path: "/Food-Campaign" },
    { title: "Applied Campaign", path: "/Applied-Campaign" },
    { title: "Food Banner", path: "/Food-Banner" },
    { title: "Banner Campaign Payment", path: "/Banner-Campaign-Payment" },
    { title: "Applied Banners", path: "/Applied-Banners" },
    { title: "Delivery Charge", path: "/Delivery-Charge" },
    { title: "Penalty Restaurants", path: "/Penalty-Restaurants" },
    { title: "Order Ratings", path: "/Order-Ratings" },
    { title: "App Update", path: "/App-Update" },
    { title: "Experts List", path: "/Experts-List" },
    { title: "Applied Experts", path: "/Applied-Experts" },
    { title: "Subscription", path: "/Subscription" },
    { title: "Service Category", path: "/Service-Category" },
    { title: "AirPort Orders", path: "/AirPort-Orders" },
    { title: "Rentals Orders", path: "/Rentals-Orders" },
    { title: "Category Analytics", path: "/Category-Analytics" },
    { title: "All Analytics", path: "/All-Analytics" },
    { title: "Airport Assigned Orders", path: "/Airport-Assigned-Orders" },
    { title: "Airport UnAssigned Orders", path: "/Airport-UnAssigned-Orders" },
    { title: "Rentals Assigned Orders", path: "/Rentals-Assigned-Orders" },
    { title: "Rentals UnAssigned Orders", path: "/Rentals-UnAssigned-Orders" },
    { title: "WareHouses", path: "/WareHouses" },
    { title: "Shop Admin", path: "/Shop-Admin" },
    { title: "Gocery Banners", path: "/Gocery-Banners" }
    
    
  ]; 
  
  function onLogin(e) {
    e.preventDefault();
    //console.log("token",localStorage.getItem('token'))
    let error = false;
    const errorObj = { ...errorsObj };
    if (OTP === "") {
      errorObj.otp = "OTP is Required";
      error = true;
    } else if (OTP.length != 4) {
      errorObj.otp = "Please Enter 4 Digit";
      error = true;
    } 
	else {
		var details = {
			StaffID: `${userDetails.staff._id}`,
			OTP: OTP,
			Token: tokens,
			Online: true,
		  };
		  axios
			.put(Baseurl.baseurl + `/staff/verify-staff`, details)
			.then((response) => {
			  if (response.data.status) {
          localStorage.setItem("OTP",response.data.status)
				swal("successfully logged in", response.data.message, "success", {
				  button: "Done",
				  timer: 1000,
				});
				dispatch(loginConfirmedAction(userDetails));
				let vig = userDetails.staff.Role;
				axios
				  .get(`${Baseurl.baseurl}/roles/get-roles`)
				  .then((response) => {
					response.data.details.map((val) => {
					  if (val.Title === vig) {
						let vikki = val.Permissions[0];
						Permission.map((val) => {
						  if (val.title === vikki) {
							history.push(`${val.path}`);
						  }
						});
					  }
					});
				  });
			  } else {
				swal("Oops", response.data.message, "error", {
				  button: "Done",
				  timer: 3000,
				});
			  }
			});
    }
	
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    // dispatch(loginAction(email, password, props.history));
  }

  return (
    <div className="login-wrapper">
      <div className="login-aside-left ">
        <Link to="/" className="login-logo align-center ">
          <img
            className=""
            src={logo2}
            alt=""
            style={{ height: 180, width: 200 }}
          />
        </Link>

        <div className="login-description">
          <div>
            <h2 className="text-white">Welcome to Go One</h2>
          </div>
          {/* <h2 className="text-white mb-4">Check the Status</h2>
					<p className="fs-12">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,</p> */}
          {/* <ul className="social-icons mt-4">
						<li><Link to={"#"}><i className="fa fa-facebook"></i></Link></li>
						<li><Link to={"#"}><i className="fa fa-twitter"></i></Link></li>
						<li><Link to={"#"}><i className="fa fa-linkedin"></i></Link></li>
					</ul> */}
          <div className="mt-5">
            {/* <Link to={"#"} className="text-white mr-4">Privacy Policy</Link>
						<Link to={"#"} className="text-white mr-4">Contact</Link> */}
            <Link to={"#"} className="text-white">
              © 2021 Go one technologies Private Limited
            </Link>
          </div>
        </div>
      </div>
      <div className="login-aside-right">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-6 col-xxl-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className=" mb-3">
                      {/*  <Link to="/">
								<img src={logo} alt="" />
                            </Link> */}
                    </div>
                    <h4 className=" mb-4  text-center">
                      Please Provide the OTP Recieved to Your Registered Number
                    </h4>
                    {/* {props.errorMessage && (
                                <div className='text-danger'>
                                    {props.errorMessage}
                                </div>
                            )} */}
                    {/* {props.successMessage && (
                                <div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
                                    {props.successMessage}
                                </div>
                            )} */}
                    <form onSubmit={onLogin}>
                      <div className="form-group">
                        {/* <label className="mb-2 ">
									  <strong>Email</strong>
									</label> */}
                        {/* <input type="email" 
									  className={`form-control ${valid?"text-primary":"text-danger"}`}
									  value={email}
									   onChange={(e) =>{
										    setEmail(e.target.value)
											const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
										    if(re.test(e.target.value.toLowerCase()))
											{
                                                setValid(true)
											}
											else
											{
												setValid(false)
											}
										}}
									   placeholder="example@gmail.com"
									/> */}
                        {/* {errors.email && <div className="text-danger fs-12">{errors.email}</div>} */}
                      </div>
                      <div className="form-group">
                        <OTPInput
                          inputStyles={{
                            width:"50%",
                            height: 68,
                            color: "#135334",
                          }}
                          value={OTP}
                          onChange={setOTP}
                          autoFocus
                          OTPLength={4}
                          otpType="number"
                          disabled={false}
                        />
                        {errors.otp && (
                          <div className="text-danger fs-12 text-center mt-3">
                            {errors.otp}
                          </div>
                        )}
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          Sign In
                        </button>
                      </div>
                    </form>
                    <div className="new-account mt-3">
                      {/* <p className="">
								Don't have an account?{" "}
								<Link className="text-primary" to="./page-register">
								  Sign up
								</Link>
							  </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
